import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Axios from 'axios';
import { BaseButton } from '../../styles/styled';

class ReimportEpisodes extends Component {
  constructor(props) {
    super(props);

    this.state = {
      status: '',
      importing: false,
    };
  }

  reImport = async () => {
    const {
      soundcast: { id: soundcastId },
    } = this.props;

    this.setState({ importing: true });
    const result = await new Promise(async resolve => {
      try {
        await Axios.post(`/api/soundcast/${soundcastId}/transition/episodes`);
        resolve(true);
      } catch (err) {
        console.log('Unable to reimport episodes', err.message);
        resolve(false);
      }
    });

    const status = result ? 'Import success' : 'Import failed';
    this.setState({ status });
    await new Promise(resolve => setTimeout(resolve, 2500));
    this.setState({ status: '', importing: false });
  };

  render() {
    const { status, importing } = this.state;
    const btnContent = importing ? 'Reimporting...' : 'Reimport Tracks';
    return (
      <BaseButton disabled={importing} className="btn btn-small" onClick={this.reImport}>
        {status || btnContent}
      </BaseButton>
    );
  }
}

ReimportEpisodes.propTypes = {
  soundcast: PropTypes.object,
};

ReimportEpisodes.defaultProps = {
  soundcast: {},
};

export default ReimportEpisodes;
